export default __webpack_public_path__ + "img/5e41a3af42cd2dafa3a4fdebf4fd63f4.svg";